import { buildStaticFileUrl } from "../../../../commons/libs/client-utils";
import useQuery from "../../../commons/libs/hooks/use-query";
import Headline from "../../components/Headline/Headline";
import LoadingIndicator from "../../components/LoadingIndicator/LoadingIndicator";
import Paragraph from "../../components/Paragraph/Paragraph";
import Text from "../../components/Text/Text";

const fetchThirdPartyNotices = async (): Promise<string> => {
  const url = buildStaticFileUrl("THIRD-PARTY-NOTICES.html");
  const response = await fetch(url.toString());
  return response.text();
};

const ThirdPartyNoticesPartial = () => {
  const thirdPartyNoticesQuery = useQuery({
    queryKey: ["thirdPartyNotices"],
    queryFn: fetchThirdPartyNotices,
    staleTime: Infinity, // File won't change during app lifetime
    onError: error => {
      throw new Error(`Failed to fetch third-party notices (status: ${error.message})`);
    }
  });

  return (
    <Text>
      <Headline>Third Party Notices</Headline>
      {thirdPartyNoticesQuery.isLoading && <LoadingIndicator size="s" />}
      {thirdPartyNoticesQuery.error && (
        <Paragraph kind="support">
          {thirdPartyNoticesQuery.error.message || "Could not load third-party notices."}
        </Paragraph>
      )}
      {thirdPartyNoticesQuery.data && <div dangerouslySetInnerHTML={{ __html: thirdPartyNoticesQuery.data }} />}
    </Text>
  );
};

export default ThirdPartyNoticesPartial;
